import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  MagazziniMovimenti,
  MagazzinoMovimenti_TableModel,
  MagazzinoMovimenti_ViewModel,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniMovimentiService extends CrudGenericsService<MagazziniMovimenti, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniMovimenti`);
    this.base = `${env.apiUrl}/api/MagazziniMovimenti/`;
  }
  GetMagazzinoMovimenti_TableModel(
    date_min: string,
    date_max: string,
    carico_true_scarico_false: boolean
  ): Observable<MagazzinoMovimenti_TableModel[]> {
    const u = `${this.base}GetMagazzinoMovimenti_TableModel?date_min=${date_min}&date_max=${date_max}&carico_true_scarico_false=${carico_true_scarico_false}`;
    return this.http.get<MagazzinoMovimenti_TableModel[]>(u);
  }
  GetMagazzinoMovimenti_ViewModel(id: number): Observable<MagazzinoMovimenti_ViewModel> {
    const u = `${this.base}GetMagazzinoMovimenti_ViewModel?id=${id}`;
    return this.http.get<MagazzinoMovimenti_ViewModel>(u);
  }
}
